import { render, staticRenderFns } from "./reports.search.component.vue?vue&type=template&id=506c9992&scoped=true&"
import script from "./reports.search.component.vue?vue&type=script&lang=js&"
export * from "./reports.search.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c9992",
  null
  
)

export default component.exports